import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";

class DeleteFeedbackModal extends Component {
  constructor() {
    super(...arguments);

    _defineProperty(this, "translate", id => this.props.intl.formatMessage({
      id: "user.feedback.modal.".concat(id)
    }));
  }

  render() {
    const {
      isOpen,
      onClose,
      onSubmit
    } = this.props;
    return /*#__PURE__*/_jsx(Modal, {
      show: isOpen,
      title: this.translate('title'),
      body: this.translate('body'),
      actions: [{
        text: this.translate('action_delete'),
        style: Modal.ActionStyling.Filled,
        theme: 'warning',
        callback: onSubmit
      }, {
        text: this.translate('action_close'),
        callback: onClose
      }]
    });
  }

}

_defineProperty(DeleteFeedbackModal, "defaultProps", {
  isOpen: false
});

export default injectIntl(DeleteFeedbackModal);